"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fab = void 0;
var Fab_1 = __importDefault(require("@material-ui/core/Fab"));
var patch_base_button_components_1 = __importDefault(require("./patch-base-button-components"));
exports.Fab = patch_base_button_components_1.default(Fab_1.default);
//# sourceMappingURL=fab.js.map